<template>
    <div class="container">
        <div class="section-sw">
            <div class="swiper-container current-wrap">
                <div class="swiper-wrapper">
                    <div class="swiper-slide current-slider" v-for="(item, index) in swiperLsit" :key="index">
                        <img :src="item">
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <img class="s-t-img" :src="sectionImgList[0]" >
        </div>
        <div class="tab-main">
            <div class="tab-view" v-for="(item, index) in tabList" :key="index" :class="[`tb-${index}`]" @click="JumpHerf(item.url)">
                <img class="icon" :src="item.img">
                <div class="t-name">{{item.name}}</div>
                <div class="t-des">{{item.des}}</div>
            </div>
        </div>
        <div class="section-btn">
            <img class="s-b-img" :src="buttonImgList[0]" @click="JumpFn('2')">
        </div>
        <div class="section" v-for="(item, index) in sectionImgList" :key="index">
            <img v-if="index > 0 && index <4" class="section-img" :src="item" >
        </div>
        <div class="section">
            <img class="s-t-img-2" :src="sectionImgList[4]" >
        </div>
        <div class="section-main">
            <div class="left">
                <div class="s-l" :class="{'active': index == activeIndex}"  
                    v-for="(item, index) in mainList" :key="index"
                    @click="tabChange(index)"
                >
                    {{item.title}}
                </div>
            </div>
            <div class="right">
                <div class="detail" v-for="(its, i) in mainList[activeIndex].detail" :key="i">
                    <div class="d-title">{{its.title}}</div>
                    <div class="d-txt" v-for="(it, is) in its.txt" :key="is">
                        {{it}}
                    </div>
                </div>
                <div class="r-other">
                    {{mainList[activeIndex].other}}
                </div>
            </div>
        </div>
        <div class="section-btn">
            <img class="s-b-img" :src="buttonImgList[1]" @click="JumpFn()">
        </div>
        <div class="section">
            <img class="s-t-img-3" :src="sectionImgList[5]" >
        </div>
        <div class="section-sw1">
            <div class="swiper-container box-wrap">
                <div class="swiper-wrapper">
                    <div class="swiper-slide current-slider" v-for="(item, index) in swiperLsit1" :key="index">
                        <img :src="item">
                    </div>
                </div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
        </div>
        <div class="section" v-for="(item, index) in sectionImgList" :key="index">
            <img v-if="index > 5 && index <8" class="section-img" :src="item" >
        </div>
        <div class="section-btn">
            <img class="s-b-img-1" :src="buttonImgList[2]" @click="JumpFn('2')">
        </div>
        <div class="section">
            <img class="section-img" :src="sectionImgList[8]" >
        </div>
        <button class="footer" @click="JumpFn()">
            <img :src="h5footerImg">
        </button>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import List from './1'
export default {
    data() {
        return {
            activeIndex:0,
            List:List,
            tabList:[],
            swiperLsit:[],
            swiperLsit1:[],
            sectionImgList:[],
            buttonImgList:[],
            mainList:[],
            h5footerImg:""
        }
    },
    created () {
        this.swiperInit()
        let temData = this.List.data
        let temDataH5 = temData.h5
        this.tabList = temData.pc.tabList
        this.mainList = temDataH5.mainList
        this.h5footerImg = temDataH5.h5footerImg
        this.swiperLsit1 = temDataH5.swiperLsit1
        this.swiperLsit = temDataH5.swiperLsit
        this.sectionImgList = temDataH5.sectionImgList
        this.buttonImgList = temDataH5.buttonImgList
    },
    methods: {
        swiperInit() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                autoplayDisableOnInteraction: false,
                autoplay: 3000,
                spaceBetween: 30,
            };
            let option1 = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                autoplayDisableOnInteraction: false,
                autoplay: 3000,
                spaceBetween: 30,
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next'
            };
            this.$nextTick(() => {
                const swiper1 = new Swiper('.current-wrap', option);
                const swiper2 = new Swiper('.box-wrap', option1);
            });
        },
        JumpHerf(url) {
            if(url) {
                window.open(url)
            }
        },
        JumpFn(val) {
            if(val == '2') {
                // 点击申请调客服
                window.location.href = "https://tb.53kf.com/code/client/90d3e270b5d355aa44bafe74fd7fe8a11/2"
            } else {
                 //报名
                handleJumpUrl('069d9569e7a84dbb934208ff2d1f7bfc')
            }
        },
        tabChange(index) {
            this.activeIndex = index
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    padding-bottom: 200px;
}
.section-sw {
    width: 100%;
    /deep/ .current-wrap {
        width: 100%;
        .swiper-wrapper {
           width: 100%;
            img {
                width: 100%;
            }
        }
    }
}
.section-sw1 {
    width: 100%;
    background-color: #f6f6f6;
    position: relative;
    overflow: hidden;
    /deep/ .box-wrap {
        margin: 70px auto;
        width: 7.467rem;
        height: 7.493rem;
        .swiper-wrapper {
            width: 7.467rem;
            height: 7.493rem;
            img {
                width: 100%;
            }
        }
    }
    .swiper-button-prev {
        background: url('https://s21.lgstatic.com/growth/activity/20210305/1614937189729.png') no-repeat center;
        background-size: 100% 100%;
        width: 0.693rem;
        height: 1.253rem;
        top: 50%;
        transform: translateY(-50%);
        left: 0.267rem;
    }
    .swiper-button-next {
        background: url('https://s21.lgstatic.com/growth/activity/20210305/1614936710019.png') no-repeat center;
        background-size: 100% 100%;
        width: 0.693rem;
        height: 1.253rem;
        top: 50%;
        transform: translateY(-50%);
        right: 0.267rem;
    }
}
.section {
    width: 100%;
    .s-t-img {
        display: block;
        margin: 66px auto 40px;
        width: 391px;
        height: 184px;
    }
    .s-t-img-2 {
        display: block;
        margin: 18px auto 49px;
        width: 554px;
        height: 140px;
    }
    .s-t-img-3 {
        display: block;
        margin: 66px auto 40px;
        width: 536px;
        height: 140px;
    }
    .section-img {
        width: 100%;
        display: block;
    }
}
.section-btn {
    width: 100%;
    .s-b-img {
        display: block;
        margin: 40px auto;
        width: 380px;
        height: 80px;
    }
    .s-b-img-1 {
        display: block;
        margin: 20px auto;
        width: 380px;
        height: 80px;
    }
}
.tab-main {
    width: 720px;
    height: 720px;
    margin: 0 auto;
    border: 1px solid #E3E3E3;
    .tab-view {
        float: left;
        width: 240px;
        height: 240px;
        box-sizing: border-box;
        overflow: hidden;
    }
    .tb-0, .tb-1, .tb-2, .tb-3, .tb-4, .tb-5 {
        border-bottom: 1px solid #E3E3E3!important;
    }
    .tb-0, .tb-1, .tb-3, .tb-4,.tb-6,.tb-7 {
        border-right: 1px solid #E3E3E3!important;
    }
    .icon {
        width: 80px;
        height: 80px;
        display: block;
        margin: 28px auto 0;
    }
    .t-name {
        font-size: 32px;
        color: #333;
        font-weight: 500;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        text-align: center;
        padding: 12px 0 4px ;
    }
    .t-des {
        font-size: 18px;
        color: #666;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        text-align: center;
        padding: 0 10px;
    }
}
.section-main {
    margin:  0 auto;
    width: 707px;
    background: #FFFAF4;
    border-radius: 8px;
    display: flex;
    .left {
        width: 175px;
        height: 100%;
        margin-right: 10px;
        background: #FF9D0B;
        font-size: 28px;
        color: #fff;
        border-radius: 8px 0px 0px 8px;
        .s-l {
            width: 175px;
            height: 150px;
            text-align: center;
            line-height: 150px;
            
        }
        .active {
            width: 185px;
            height: 150px;
            margin: 0;
            background: #FF6A14;
            border-radius: 8px 0px 0px 8px;
        }
    }
    .right {
        position: relative;
        flex: 1;
        height: 100%;
        padding: 30px 0;
        .detail {
            width: 100%;
            padding: 20px 22px 32px;
            box-sizing: border-box;
            .d-title {
                font-size: 30px;
                color: #333;
                padding-bottom: 12px;
            }
            .d-txt {
                font-size: 24px;
                padding-bottom: 2px;
                color: #666;
            }
        }
        .r-other {
            font-size: 24px;
            color: #333;
            font-weight: bold;
            padding: 20px 30px 10px;
        }
    }
}
.footer {
    width: 100%;
    position: fixed;
    bottom: 0;
    background-color:transparent;
    border: none;
    z-index: 999;
    img {
        width: 100%;
        display: block;
    }
}
</style>